import React from 'react';
import { Base } from './Base';
import { Text, TextLink } from './Text';
import { Link } from 'react-router-dom';
import { CompileIconGray } from './icons';
import { mpEvent, MPEvents } from 'src/utils/mixpanel';

interface EPControWasDueLiveProps {
  control: {
    id: string;
    name: string;
  };
  isToday?: boolean;
}

// deprecated?
export const EPControWasDueLive: React.FC<EPControWasDueLiveProps> = ({ control, isToday }) => {
  return (
    <Base
      iconComponent={<CompileIconGray />}
      constentComponent={
        <Text $isPast={!isToday}>
          Control{' '}
          <Link
            to={`/risk-management/control/${control.id}`}
            onClick={() =>
              mpEvent(MPEvents.Link, {
                source: {
                  value: ['Timeline'],
                },
                destination: {
                  value: ['Control'],
                  params: {
                    id: control.id,
                  },
                },
                tags: ['TIMELINE', 'RMP'],
              })
            }
          >
            <TextLink $isPast={!isToday}>{control.name}</TextLink>
          </Link>{' '}
          was due to be live.
        </Text>
      }
    />
  );
};
